import { alertPriority } from '@aviation/shared-sdk/aviation/alerts';
export const ALERT_PRIORITY = {
    warning: alertPriority('warning'),
    caution: alertPriority('caution'),
    advisory: alertPriority('advisory'),
};
export const DEFAULT_MAX_VISIBLE_ALERTS = 3;
//# sourceMappingURL=types.js.map